export const FULL_STACK = 'Full Stack Development';
export const FRONT_END = 'Front End Development';
export const BACK_END = 'Back End Development';
export const DATABASE = 'Database Management';
export const CLOUD = 'DevOps & Cloud Fundamentals';